export function mapCashflowError(code: string): string {
  switch (code) {
    case "DUPLICATE_MONTH":
      return "cashflow.errors.duplicate_month";
    case "HAS_ACTUALS":
      return "cashflow.errors.has_actuals";
    case "INVALID_ACCOUNT":
      return "cashflow.errors.invalid_account";
    case "NOT_DUE_IN_MONTH":
      return "cashflow.errors.not_due_in_month";
    case "ACTUALS_CONFLICT":
      return "cashflow.errors.actuals_conflict";
    case "VALIDATION_ERROR":
      return "cashflow.errors.validation";
    case "NOT_FOUND":
      return "cashflow.errors.not_found";
    case "AUTHENTICATION_ERROR":
      return "errors.unauthenticated";
    default:
      return "errors.unknown";
  }
}
